export const InvoicesTabsIds = {
  TAX_INVOICES: 'taxInvoices',
  PROFORMA_INVOICES: 'proformaInvoices',
};
